import React, { useState, useEffect } from 'react';
import { Button, Modal, TextField, Stack, Select, MenuItem, FormControl, InputLabel, Box, Typography } from '@mui/material';
import radioProgramService from '../../services/radioProgram.services';
import CircularProgress from "@mui/material/CircularProgress";


const CreateShowModal = ({ isOpen, onClose, openSuccessModal, closeSuccessModal, setRadioProgramsFromServer, modifiedData }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [radioShows, setRadioShows] = useState([]);
    const [daysMultipleCreation, setDaysMultipleCreation] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        description: " ",
        radio_show_id: 1,
        days: '',
        start: '',
        end: '',
    });
    useEffect(() => {
        setFormData({
            title: '',
            description: '',
            radio_show_id: 1,
            days: '',
            start: '',
            end: '',
        });
        setFormErrors({
            title: '',
            description: '',
            days: '',
            start: '',
            end: '',
        });

        radioProgramService.getAllRadioShows().then((response) => {
            setRadioShows(response.data);
        }
        );
    }
        , [isOpen]);


    const [formErrors, setFormErrors] = useState({
        title: '',
        description: '',
        days: '',
        start: '',
        end: '',
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        // Clear the error for the current field when there's a change
        setFormErrors({
            ...formErrors,
            [e.target.name]: '',
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newFormErrors = {};

        // Validate each field
        if (!formData.title) {
            newFormErrors.title = "Le titre est requis.";
            isValid = false;
        }

        // if (!formData.description) {
        //     newFormErrors.description = "La description est requise.";
        //     isValid = false;
        // }

        if (daysMultipleCreation.length === 0) {
            newFormErrors.days = "Le jour est requis.";
            isValid = false;
        }
        // if (!formData.radio_show_id) {
        //     newFormErrors.radio_show_id = "Le  programme radio est requis.";
        //     isValid = false;
        // }

        if (!formData.start) {
            newFormErrors.start = "L'heure de début est requise.";
            isValid = false;
        } else if (!formData.end) {
            newFormErrors.end = "L'heure de fin est requise.";
            isValid = false;
        } else {
            const startTime = new Date(`2024-01-01 ${formData.start}`);
            const endTime = new Date(`2024-01-01 ${formData.end}`);

            if (startTime >= endTime) {
                newFormErrors.start = "L'heure de début doit être antérieure à l'heure de fin.";
                isValid = false;
            }
        }

        setFormErrors(newFormErrors);
        return isValid;
    };

    const handleCreate = () => {
        if (validateForm()) {
            const mappedDays = daysMultipleCreation.map(day => {
                return {
                    title: formData.title,
                    description: formData.description === "" ? " " : formData.description,
                    radio_show_id: formData.radio_show_id,
                    days: day,
                    date_start: formData.start,
                    date_end: formData.end
                };
            }
            );
            setIsLoading(true);

            radioProgramService.createRadioProgram(mappedDays).then((response) => {
                openSuccessModal();
                radioProgramService.getRadioPrograms().then((res) => {
                    setRadioProgramsFromServer(modifiedData(res.data))
                })
                setTimeout(() => {
                    setIsLoading(false);
                    closeSuccessModal();
                }, 2000);
            }
            ).catch((error) => {
                setIsLoading(false);
                console.log(error);
            }
            );

            onClose();
        }
    };
    const handleSelectDays = (event) => {
        setDaysMultipleCreation(event.target.value);
    };
    const translationMap = {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche'
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 6,
                    width: 600,
                    height: 700,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, boxShadow: 24, p: 4 }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>
                        Créer un programme
                    </Typography>
                    <Stack spacing={2}>
                        <TextField label="Titre" name="title" value={formData.title} onChange={handleInputChange} fullWidth error={!!formErrors.title} helperText={formErrors.title} />
                        <TextField label="Description" name="description" value={formData.description} onChange={handleInputChange} fullWidth error={!!formErrors.description} helperText={formErrors.description} />
                        <FormControl fullWidth error={!!formErrors.days}>
                            <InputLabel>Jour</InputLabel>
                            <Select multiple name="days" value={daysMultipleCreation} onChange={handleSelectDays}
                                renderValue={(selected) => selected.map(day => translationMap[day]).join(', ')}>
                                <MenuItem value="monday">Lundi</MenuItem>
                                <MenuItem value="tuesday">Mardi</MenuItem>
                                <MenuItem value="wednesday">Mercredi</MenuItem>
                                <MenuItem value="thursday">Jeudi</MenuItem>
                                <MenuItem value="friday">Vendredi</MenuItem>
                                <MenuItem value="saturday">Samedi</MenuItem>
                                <MenuItem value="sunday">Dimanche</MenuItem>
                            </Select>
                            {formErrors.days && <Typography variant="caption" color="error">{formErrors.days}</Typography>}

                        </FormControl>
                        {/* <FormControl fullWidth error={!!formErrors.radio_show_id}>
                            <InputLabel>Programme radio </InputLabel>
                            <Select name="radio_show_id" value={formData.radio_show_id} onChange={handleInputChange}>
                                {radioShows.map((radioShow) => (
                                    <MenuItem value={radioShow.id}>{radioShow.name}</MenuItem>
                                ))}
                            </Select>
                            {formErrors.radio_show_id && <Typography variant="caption" color="error">{formErrors.radio_show_id}</Typography>}
                        </FormControl> */}
                        <TextField label="Heure de début" type="time" name="start" value={formData.start} onChange={handleInputChange} fullWidth error={!!formErrors.start} helperText={formErrors.start} />
                        <TextField label="Heure de fin" type="time" name="end" value={formData.end} onChange={handleInputChange} fullWidth error={!!formErrors.end} helperText={formErrors.end} />
                        <Button disabled={isLoading} variant="contained" onClick={handleCreate}>{isLoading ? <CircularProgress className="mx-5" color="inherit" /> : "Créer"}</Button>
                    </Stack>

                </div>
            </Box>
        </Modal>
    );
};

export default CreateShowModal;
